import type { IconSvgObject } from './types';

const FileCodeCornerIcon: IconSvgObject = [
  ["path", { d: "M5 12V4C5 2.89543 5.89543 2 7 2H14L21 9V20C21 21.1046 20.1046 22 19 22H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 16L13 19L10 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 16L3 19L6 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 2V7C14 8.10457 14.8954 9 16 9H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default FileCodeCornerIcon;
